import React, { Component } from "react";
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import NovedadesHelper from '../../../../../Common/Helpers/NovedadesHelper';

class VigenciaDias extends Component {
    constructor(props) {
        super(props)
    }
    /**
     * 
     */
    componentDidMount() {
        if (!this.props.data.vigenciaTarjeta) {
            this.props.getDiasVigencia();
        }
    }
    /**
     * 
     */
    render() {
        const { props } = this;
        const { data, tarjeta } = props;
        let tarjetas;
        let vigencias = ((data.vigenciaTarjeta) ? JSON.parse(JSON.stringify(data.vigenciaTarjeta)) : []);

        let vigenciaDiasNovedad = NovedadesHelper.SelectComboConNovedadPorCampos(this.props.codigoNovedad,
            tarjeta.Vigencia,
            data.novedadesTarjetaDatos,
            data.esNovedadEditada,
            vigencias,
            [{ Clave: "TarjetaCreditoId", Valor: tarjeta.TarjetaCreditoId }]);

        if (vigenciaDiasNovedad.novedadSelectCombo) {
            if (vigenciaDiasNovedad.novedadSelectCombo.ValorAnterior == "") {
                vigenciaDiasNovedad.novedadSelectCombo.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        return <div className="col-xs-12">
            <div>
                <label className="label-primary">Días de Vigencia</label>
            </div>
            <div>
                <label className="label-secondary">{(vigenciaDiasNovedad.selectComboDescripcion || "Sin especificar")}</label>
            </div>
        </div>
    }
}

export default VigenciaDias;